import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import bedHotel from '@shared/assets/bedHotel.svg';

const RoomSummary = ({ roomInfo }) => {
  if (!roomInfo) return null;

  const { totalRooms, total_passengers } = roomInfo;

  return (
    <Box
      sx={{
        width: { xs: '100%', sm: '50%' },
      }}
    >
      <Grid container justifyContent="space-between" spacing={0}>
        {/* Habitaciones */}
        <Grid
          item
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <img src={bedHotel} alt="bedIcon" />
          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: 700,
              color: '#636466',
              ml: 0.5,
              display: 'flex',
            }}
          >
            {totalRooms}
            <Box
              component="span"
              sx={{
                display: { xs: 'block', sm: 'none' },
                ml: 0.5,
              }}
            >
              {totalRooms > 1 ? 'Habitaciones' : 'Habitación'}
            </Box>
          </Typography>
        </Grid>

        {/* Pasajeros */}
        <Grid
          item
          sx={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <SupervisorAccountIcon sx={{ color: '#636466' }} />
          <Typography
            sx={{
              fontSize: '15px',
              fontWeight: 700,
              color: '#636466',
              ml: 0.5,
              display: 'flex',
            }}
          >
            {total_passengers}
            <Box
              component="span"
              sx={{
                display: { xs: 'block', sm: 'none' },
                ml: 0.5,
              }}
            >
              {total_passengers > 1 ? 'Personas' : 'Persona'}
            </Box>
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RoomSummary;
